const defaultState = "";

export const csrfTokenReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SAVE_CSRF":
      localStorage.setItem('csrf', JSON.stringify(action.payload));

      return action.payload;

    case "REMOVE_CSRF":
      return defaultState;
    default:
      return state;
  }
};
